/**
 * @author vishwadeep.kapoor
 * @Date: 2018-08-23 15:00:44
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-04 01:44:55
 */
/**
* @see /client/containers/GiftCardsList/index.js
* GiftCard
*/

import React, { PureComponent, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { func, string, shape, bool, array, number } from 'prop-types';
import { Card, Row, Col, Input, Carousel } from 'antd';
import styled from 'styled-components';
import FontAwesomeIcon from 'react-fontawesome';

import { AppWrappperHOC } from '../Root/HOC';
import {
  DEFAULT_REDEEMGIFTCARD_PAYLOAD,
  TYPE_FILTERS,
  MAKE_FILTER_ACTIVE,
  CONSTRUCT_MOBILE_FILTER_KEYS,
  SWITCH_PAYLOADS,
  TEXT_NO_GIFTCARD,
  CONSTRUCT_DIS_KEYS,
  CONSTRUCT_FILTER_ACTION_PAYLOAD,
  MAP_GIFTCARD_KEYS,
  TEXT_NO_MERCHANT,
  GIFT_TEXT_HEADER,
  LYRA_DUMMY_FILTER,
} from './constants';
import {
  selectCategoryList,
  discountList,
  brandList,
  giftCardList,
  selectGiftCardJS,
} from '../GiftCardsList/selectors';
import { cartItemList, select_isBoolean } from '../GiftCardCart/selectors';
import Container from '../../components/Container';
import ListFilters from '../../components/ListFilters';
import ListFiltersMobile from '../../components/ListFilters/indexMobile';
import TabMenu from '../../components/TabMenu';
import { fetchCategoryList, fetchGiftCardList } from '../GiftCardsList/actions';
import { addToCartAction, deleteCartItem, fetchCartItemList, createCart } from '../GiftCardCart/actions';
import Pagination from '../../components/Pagination';
import {
  DEFAULT_GIFTCARD_PAYLOAD,
  ADDTOCART_PAYLOAD_STRUCTURE,
  DEFAULT_GIFTCARD_CLIENT,
  VALIDATE_MERCHANDISE,
  DEFAULT_MERCHANDISE_PRODUCT_TYPES,
  DEFAULT_GIFTCARD_PAYLOAD_MANIPAL,
  DEFAULT_PRODUCT_TYPES,
  DEFAULT_GIFTCARD_SPECIAL_DEALS_AND_OFFERS,
  DEFAULT_GIFTCARD_PAYLOAD_PROPEL_CORPORATE_GIFTING,
  DEFAULT_EVOUCHER_MERCHANDISE,
} from '../GiftCardsList/constants';
import { utils, constants, fbTracker, eventTracking } from '../../devUtils';
import { isMobileScreen, selectLoggedIn, selectHeaderContainerJS } from '../HeaderContainer/selectors';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import { CREATE_CART_PAYLOAD } from '../GiftCardCart/constants';
import { resetPopup } from '../HeaderContainer/actions';
import { LINK_ARRAY } from '../GiftCardLanding/constants';
import GiftLandingCard from '../GiftCardLanding/GiftLandingCard';
import { displayLoginFrom } from '../LoginPage/actions';
import { MobileFiltes } from '../RestaurantsList';
import { MAKE_FILTER_TRACKING_LABEL } from '../RestaurantsList/constants';
import Loader from '../../components/Loader';
import endPoints from '../../config/endPoints';
// import Breadcrumb from '../../components/Breadcrumb';
import { CONFIG_CLIENT_UI } from '../ClientLogin/constants';
import StyledClientLogin from '../ClientLogin/styledClientLogin';
import { StyledCouponCodeBox, StyledPropelCorporateGiftingCampaignHeader } from './StyledGiftCard';
import { IMG_IMPORTS } from '../../devUtils/assests';
import theme from '../../theme';
import { SubTitle } from '../../components';
import LyraGiftLandingCard from '../GiftCardLanding/LyraGiftLandingCard ';
import { storeLyraGiftCard } from '../GiftCardLanding/actions';
import { selectLyraGiftCard } from '../GiftCardLanding/selectors';

const { Search } = Input;

const StyledSearchBox = styled.div`
margin-bottom: 15px;
.search_box{
  .ant-input-wrapper {
    .ant-input{
      padding: 24px;
      background-color: ${(props) => props.theme.lightWhite};
      border: none;
      &:focus{
        box-shadow: none;
      }
    }
    .ant-btn-primary{
      border-radius: 4px;
      font-size: 20px;
      padding: 11px 22px;
    }
    .ant-input-suffix{
      z-index: 1;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
    width: 100%;
  };
}
`;
class GiftCard extends PureComponent {
  constructor(props) {
    super(props);
    this.filterCheckList = { category: [], brand: [], discount: [], type: [] }; // this.stateLessKeys
    this.filterNamesList = { category: [], brand: [], discount: [], type: [] }; // for event tracking
    const {
      isMobileWindow, history, getDiscountList, getBrandList, getUserDetails, client_id, filter,
      filter: { filterId, filterName } = {},
      history: { location: { pathname = '' } } = {},
    } = props;
    this.variationSelectList = [];
    this.cart = null;
    this.state = {
      location: history.location,
      CategoryListArray: [],
      DiscountListArray: getDiscountList,
      BrandListArray: getBrandList,
      TypeListArray: TYPE_FILTERS,
      dealFilter: [],
      collectionFilter: [],
      giftCardDynamicList: {},
      userDetails: getUserDetails,
      showModal: false,
      cartData: {},
      filterObj: props.filter && props.filter,
      selectedFilterKey: '',
      isShowFilter: false,
      mobileFilterData: CONSTRUCT_MOBILE_FILTER_KEYS,
      urlPath: pathname,
      loginRedirectLink: '',
      searchText: '',
      voucherRemarks: '',
      voucherAmount: 0,
    };
    this.stateLessKeys = {
      serverPayload: {},
      temp_payload: {},
      isMobileWindow,
      payloadKey: 'category',
      // filterKey,
      data: [],
      isThisRedeemPage: false,
      productName: '',
    };
    this.onChildEvents = this.onChildEvents.bind(this);
    this.onCheckBoxClicked = this.onCheckBoxClicked.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.emptyCart = this.emptyCart.bind(this);
    this.goToOrderSummery = this.goToOrderSummery.bind(this);
    this.handleChangeFilters = this.handleChangeFilters.bind(this);
    this.mobileFilterClick = this.mobileFilterClick.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.applyCheckedFilters = this.applyCheckedFilters.bind(this);
    this.handleShowLogin = this.handleShowLogin.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    if (client_id === DEFAULT_GIFTCARD_CLIENT) {
      const _data = DEFAULT_GIFTCARD_PAYLOAD;
      if (filterName && filterId) {
        _data[filterName] = filterId;
      }
      this.stateLessKeys.serverPayload = _data;
      this.stateLessKeys.isThisRedeemPage = false;
    } else {
      this.stateLessKeys.isThisRedeemPage = true;
      this.stateLessKeys.serverPayload = VALIDATE_MERCHANDISE({ ...DEFAULT_REDEEMGIFTCARD_PAYLOAD, client_ids: client_id }, getUserDetails);
    }
    if (filter && filter.filterId && filter.filterName) {
      this.filterCheckList.category.push(filter.filterId);
    }
  }

  componentWillMount() {
    const {
      onGetCategoryList,
      onGetCartItemsList,
      client_id,
    } = this.props;
    onGetCategoryList({
      client_ids: client_id !== DEFAULT_GIFTCARD_CLIENT ? client_id : '',
      client_series: this.getClientSeries(),
    });
    const { cart } = this.state.userDetails;
    if (cart && cart.id) {
      this.cart = cart;
      onGetCartItemsList(cart.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      getUserDetails,
      client_id,
      isLogedIn,
      onGetCartItemsList,
      history,
    } = nextProps;
    const {
      getUserDetails: _getUserDetails,
      isLogedIn: _isLogedIn,
      onGetCategoryList,
    } = this.props;
    const { loginRedirectLink } = this.state;
    if (!utils.isEqual(this.props, nextProps)) {
      this.filterDataFromStoreBeforeRender(nextProps);
    }
    if (!utils.isEqual(_getUserDetails, getUserDetails)) {
      this.setState({ userDetails: getUserDetails });
      this.cart = getUserDetails.cart;
    }
    if (!utils.isEqual(_isLogedIn, isLogedIn)) {
      if (loginRedirectLink) {
        utils.forceRedirect(history, { pathname: loginRedirectLink, state: { client_id } });
      } else {
        const { cart } = getUserDetails;
        if (cart && cart.id) {
          this.variationSelectList = [];
          onGetCartItemsList(cart.id);
          onGetCategoryList({
            client_ids: client_id !== DEFAULT_GIFTCARD_CLIENT ? client_id : '',
            client_series: this.getClientSeries(),
          });
        }
      }
    }
  }

  componentDidUpdate() {
    // page reload if browser back button pressed
    window.onpopstate = () => {
      window.location.reload(false);
    };
  }

  /**
   * @param {*string/object} value: name
   * @desc triggring the event for fbAnalytics
   */
  onChildEvents(type, value, name, trackAction) {
    const { isThisRedeemPage } = this.stateLessKeys;
    const { isLogedIn } = this.props;
    if (!isLogedIn && ['detailsPage', 'addToCart'].includes(type)) {
      if (type === 'detailsPage') {
        this.setState({ loginRedirectLink: `${constants.LINK_GIFTCARD_DETAILS}/${value}` });
      }
      this.handleShowLogin();
    } else if (type === 'detailsPage') {
      const { history, client_id } = this.props;
      history.push({ pathname: `${constants.LINK_GIFTCARD_DETAILS}/${value}`, state: { client_id } });
      const actionType = trackAction === 'image' ? 'List - Card Image Click' : 'List - Card Name Click';
      eventTracking.triggerEvent(isThisRedeemPage ? 'Redeem ZSC' : 'Gift Cards', actionType, value);
      fbTracker.VIEW_CONTENT(value, 'product', value);
    } else if (type === 'variationChange') {
      eventTracking.triggerEvent(isThisRedeemPage ? 'Redeem ZSC' : 'Gift Cards', 'List - Select Value', `<${name}>`);
      this.triggerVariationChange(value);
    } else if (type === 'addToCart') {
      this.triggerAddToCart(value, name);
    }
  }

  onClientChecked(pathname) {
    switch (pathname) {
      case constants.LINK_SPECIAL_DEALS_AND_OFFERS:
        return DEFAULT_GIFTCARD_SPECIAL_DEALS_AND_OFFERS;
      case constants.LINK_PROPEL_CORPORATE_GIFITING_HOME:
        return DEFAULT_GIFTCARD_PAYLOAD_PROPEL_CORPORATE_GIFTING;
      case constants.LINK_CLIENT_MANIPAL:
        return DEFAULT_GIFTCARD_PAYLOAD_MANIPAL;
      default:
        return DEFAULT_GIFTCARD_PAYLOAD;
    }
  }

  /**
   * mobile + web
   */
  onCheckBoxClicked(type, value, checked, filterName, otherParams) {
    const {
      history: {
        location: {
          pathname,
        },
      },
      getUserDetails,
    } = this.props;
    const {
      DiscountListArray,
    } = this.state;
    const {
      client_id,
    } = this.props;
    const {
      isThisRedeemPage,
    } = this.stateLessKeys;
    this.filterCheckList = this.constructFilterArray(this.filterCheckList, type, value, checked, otherParams);
    let setPayload = {};
    const { searchText: name } = this.state;
    if (client_id === DEFAULT_GIFTCARD_CLIENT) {
      const giftCardPayload = (this.onClientChecked(pathname));
      setPayload = CONSTRUCT_FILTER_ACTION_PAYLOAD(this.filterCheckList, giftCardPayload, DiscountListArray, name);
    } else {
      const payload = DEFAULT_REDEEMGIFTCARD_PAYLOAD;
      payload.client_ids = client_id;
      setPayload = CONSTRUCT_FILTER_ACTION_PAYLOAD(this.filterCheckList, payload, DiscountListArray, name);
    }
    const { category, discount, type: filterType, brand } = this.filterNamesList;
    eventTracking.triggerEvent(isThisRedeemPage ? 'Redeem ZSC' : 'Gift Cards', 'List - Filters', MAKE_FILTER_TRACKING_LABEL([category, discount, filterType, brand]));
    this.fetchData(VALIDATE_MERCHANDISE(setPayload, getUserDetails));
  }

  getClientSeries() {
    const {
      history: {
        location: {
          pathname = '',
        } = {},
      } = {},
    } = this.props;
    switch (pathname) {
      case constants.LINK_CLIENT_MANIPAL:
        return endPoints.MANIPAL_SERIES;
      case constants.LINK_PROPEL_CORPORATE_GIFITING_HOME:
        return endPoints.PROPEL_CORPORATE_GIFTING;
      default:
        return undefined;
    }
  }

  constructFilterArray(data, type, value, checked, { isParentFilter, parentId }) {
    let curSubCategoryIndex = -1;
    let curParentCategoryIndex = -1;
    let curParentSubCategoryIndex = -1;
    const _data = { ...data };
    const index = _data[type].indexOf(value);
    const { CategoryListArray } = this.state;
    curParentCategoryIndex = CategoryListArray.findIndex(({ id }) => (id === (isParentFilter ? value : (parentId || value))));
    if (type === 'category' && isParentFilter) { // this is for the parent category selection
      curSubCategoryIndex = CategoryListArray.findIndex(({ id }) => (id === value));
    } else if (type === 'category' && parentId && curParentCategoryIndex !== -1) { // this is for sub-category
      curParentSubCategoryIndex = utils.lodashFindIndex(CategoryListArray[curParentCategoryIndex].sub_categories, { id: value });
      CategoryListArray[curParentCategoryIndex].sub_categories[curParentSubCategoryIndex].isChecked = checked;
      this.setState({ CategoryListArray });
    }
    if (index > -1) {
      _data[type].splice(index, 1);
      if (_data[type].indexOf(parentId) > -1 && !isParentFilter) {
        _data[type].splice(_data[type].indexOf(parentId), 1);
      }
      if (curParentCategoryIndex !== -1) {
        CategoryListArray[curParentCategoryIndex].isChecked = checked;
      }
      if (curSubCategoryIndex !== -1) {
        const activeCategoryAry = utils.lodashMap(CategoryListArray[curSubCategoryIndex].sub_categories, 'id');
        CategoryListArray[curSubCategoryIndex].sub_categories =
          CategoryListArray[curSubCategoryIndex].sub_categories.map((item) => ({ ...item, ...{ isChecked: false } }));

        _data[type] = _data[type].filter((item) => !activeCategoryAry.includes(item));
      }
    } else {
      _data[type].push(value);
      if (curSubCategoryIndex !== -1) {
        CategoryListArray[curSubCategoryIndex].isChecked = checked;
        CategoryListArray[curSubCategoryIndex].sub_categories =
          CategoryListArray[curSubCategoryIndex].sub_categories.map((item) => ({ ...item, ...{ isChecked: true } }));

        CategoryListArray[curSubCategoryIndex].sub_categories.map(({ id }) => {
          if (_data[type].indexOf(id) === -1) {
            _data[type].push(id);
          }
          return true;
        });
        this.setState({ CategoryListArray });
      }
    }
    return _data;
  }

  fetchData(payload) {
    this.stateLessKeys.serverPayload = payload;
    this.props.onGetGiftCardList(payload);
  }

  closeModal() {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  }

  goToOrderSummery() {
    this.closeModal();
    // here need to trigger ordersummery page
    const { history } = this.props;
    this.closeModal();
    utils.forceRedirect(history, { pathname: constants.LINK_ORDER_SUMMARY });
  }

  emptyCart() {
    this.closeModal();
    const {
      userDetails: {
        cart: {
          id,
        },
      },
    } = this.state;
    const {
      client_id,
    } = this.props;
    const {
      temp_payload,
      isThisRedeemPage,
      productName,
    } = this.stateLessKeys;
    const {
      history,
      onDeleteCartItem,
    } = this.props;
    const cartData = { ...this.state.cartData };
    const dataObj = { items: [], cartId: id };
    if (cartData && cartData.order && cartData.order.items.length > 0) {
      const dataItems = cartData.order.items;
      dataItems.forEach((element) => {
        dataObj.items.push({ product_variation_id: element.variation.id });
      });
      onDeleteCartItem(dataObj, 'empty', client_id, temp_payload, 'addToCart', history, { productName, isThisRedeemPage });
    }
  }

  /**
   * @todo Need to check physical or evoucher here
   */
  triggerAddToCart(value, productName) {
    const {
      userDetails: {
        email,
        phone: phone_numbers,
        cart,
      },
    } = this.state;
    const {
      client_id,
    } = this.props;
    const {
      history,
      isLogedIn,
      onCreateCartAction,
      onAddToCartAction,
      onClearError,
      onChangeLoginModalDisplay,
    } = this.props;
    const {
      isThisRedeemPage,
    } = this.stateLessKeys;
    if (isLogedIn) {
      const data = this.variationSelectList;
      const payload = ADDTOCART_PAYLOAD_STRUCTURE;
      payload.item.free_field_value = null;
      // payload.name = name; // for event tracking
      let proceedAddtoCart = false;
      if (data.length > 0) {
        data.forEach((element) => {
          if (element.product_id === value.product_id) {
            payload.item.product_variation_id = element.variation_id;
            payload.item.quantity = 1;
            payload.item.shipping_address = { email, phone_numbers };
            proceedAddtoCart = true;
          }
        });
        if (proceedAddtoCart) {
          this.analyticsAddToCart(value);
          const cartData = { ...this.state.cartData };
          if (cartData && cart && Object.keys(cart).length !== 0 && cartData.order && cartData.order.zaggle_card_client_id === client_id) {
            // here comes cart clientId is matched with requested product clientId
            onAddToCartAction(payload, cart.id, 'addToCart', history, { productName, isThisRedeemPage });
            this.variationSelectList = [];
          } else if (this.cart === null || Object.keys(this.cart).length === 0) {
            // here comes when there is no cartId in the profile
            // need to create cart and add requested product to cart
            const payload1 = utils.lodashCloneDeep(CREATE_CART_PAYLOAD);
            payload1.order.items.push(payload.item);
            payload1.order.zaggle_card_client_id = client_id;
            onCreateCartAction(payload1, { actionType: 'addToCart', history, productName, isThisRedeemPage });
            this.variationSelectList = [];
          } else if (cartData && cartData.order && cartData.order.items && cartData.order.items.length === 0) {
            // here comes cart has no items and clientId is not matched with requested product clientId
            // need to update exhisting clientId with requested clientId and add that product to cart
            const history_const = {
              clientId: client_id,
              cartId: cart.id,
              history,
            };
            onAddToCartAction(payload, cart.id, 'updateClient', history_const, { productName, isThisRedeemPage });
            this.variationSelectList = [];
          } else {
            // here comes cart has more items and clientId is not matched with requested product clientId
            this.closeModal();
            this.stateLessKeys = {
              temp_payload: payload,
              productName,
            };
          }
        } else {
          onClearError(constants.ALERT_CHOOSE_VARIATION, 'error');
        }
      } else {
        onClearError(constants.ALERT_CHOOSE_VARIATION, 'error');
      }
    } else {
      onChangeLoginModalDisplay(true);
    }
  }

  /**
   * @func analyticsAddToCart fb analytics
   */
  analyticsAddToCart(value) {
    const { getDynamicGiftCardList: { data: productList } } = this.props;
    const selectedProduct = utils.lodashFind(productList, { id: value.product_id }) || {};
    const activeVariation_id = utils.lodashFind(this.variationSelectList, { product_id: value.product_id }) || {};
    const getSelectedValue = utils.lodashFind(selectedProduct.variations, { id: activeVariation_id.variation_id }) || {};
    fbTracker.ADD_TO_CART(selectedProduct.name, value.product_id, 'product', null, getSelectedValue.price_cents);
  }

  triggerVariationChange(value) {
    const data = this.variationSelectList;
    let matched = false;
    if (data.length > 0) {
      data.forEach((element, index) => {
        if (element.product_id === value.product_id) {
          data[index].variation_id = value.variation_id;
          matched = true;
        }
      });
      if (!matched) {
        data.push({ ...value });
        this.variationSelectList = data;
      }
    } else {
      data.push({ ...value });
      this.variationSelectList = data;
    }
  }

  filterDataFromStoreBeforeRender(data) {
    const { getCategoryList: CategoryListArray, getDiscountList: DiscountListArray,
      getBrandList: BrandListArray, getDynamicGiftCardList: giftCardData, getCartItemList: cartData } = data;
    const { payloadKey = 'category', filterTitle } = this.stateLessKeys;
    this.markCheckboxFilter(utils.updateObjectKeys(utils.lodashFilter(CategoryListArray, { status: true }), 'filterName', 'name'), 'category');
    this.markCheckboxFilter(CONSTRUCT_DIS_KEYS(DiscountListArray, 'min', 'max'));
    this.markCheckboxFilter(utils.updateObjectKeys(utils.arraySlice(BrandListArray, 0, 16), 'filterName', 'name'));
    const _giftCardData = { ...giftCardData };
    _giftCardData.data = MAP_GIFTCARD_KEYS(_giftCardData.data);
    if (this.props.isMobileWindow) {
      const { TypeListArray, dealFilter, collectionFilter } = this.state;
      SWITCH_PAYLOADS({ CategoryListArray, TypeListArray, DiscountListArray, BrandListArray, dealFilter, collectionFilter }, payloadKey, filterTitle, this.applyCheckedFilters);
    }
    this.setState({ CategoryListArray, DiscountListArray, BrandListArray, giftCardDynamicList: _giftCardData, cartData });
  }

  markCheckboxFilter(data, type) {
    let _data = data;
    const { filter = null } = this.props;
    const { CategoryListArray } = this.state;
    if (type === 'category') {
      _data = _data.map((item) => {
        const curIndex = utils.lodashFindIndex(CategoryListArray, { id: item.id });
        if (curIndex !== -1) {
          item.sub_categories = CategoryListArray[curIndex].sub_categories;
          item.isChecked = CategoryListArray[curIndex].isChecked;
        }
        return item;
      });
    }
    if (filter) {
      const reqIndex = utils.lodashFindIndex(data, { id: filter.filterId });
      if (reqIndex !== -1) {
        _data[reqIndex].isChecked = true;
      }
    }
  }

  /**
   * mobile filter change
   */
  handleChangeFilters(key, filterTitle) {
    const { mobileFilterData } = this.state;
    let _mobileFilterData = [...mobileFilterData];
    _mobileFilterData = MAKE_FILTER_ACTIVE(_mobileFilterData, key, filterTitle);
    SWITCH_PAYLOADS(this.state, key, filterTitle, this.applyCheckedFilters);
    this.setState({ mobileFilterData: _mobileFilterData });
  }

  applyCheckedFilters(type, data) {
    this.stateLessKeys.payloadKey = type;
    this.stateLessKeys.data = data;
  }

  handleApply() {
    const { isShowFilter } = this.state;
    this.setState({ isShowFilter: !isShowFilter });
  }

  mobileFilterClick() {
    const { isShowFilter } = this.state;
    this.setState({ isShowFilter: !isShowFilter });
  }

  handleShowLogin() {
    const { onChangeLoginModalDisplay } = this.props;
    onChangeLoginModalDisplay(true);
  }

  handleSearch(value) {
    const {
      initialPayload,
      onGetGiftCardList,
    } = this.props;
    const { category = [] } = this.filterCheckList;
    this.setState({ searchText: value });
    onGetGiftCardList({ ...initialPayload, category_ids: category.join(','), name: value });
  }

  dynamicPayload() {
    const {
      urlPath,
      searchText,
    } = this.state;
    const { category = [] } = this.filterCheckList;
    const { serverPayload } = this.stateLessKeys;
    switch (urlPath) {
      case constants.LINK_SPECIAL_DEALS_AND_OFFERS:
        return ({
          ...DEFAULT_GIFTCARD_PAYLOAD,
          category_ids: category.join(','),
          product_types: DEFAULT_PRODUCT_TYPES,
          name: searchText,
          min_discount: 5,
          max_discount: 100,
        });
      case constants.LINK_PROPEL_CORPORATE_GIFITING_HOME:
        return ({
          ...DEFAULT_GIFTCARD_PAYLOAD,
          category_ids: category.join(','),
          product_types: DEFAULT_EVOUCHER_MERCHANDISE,
          client_series: endPoints.PROPEL_CORPORATE_GIFTING,
          name: searchText,
        });
      case constants.LINK_CLIENT_MANIPAL:
        return ({
          ...DEFAULT_GIFTCARD_PAYLOAD,
          category_ids: category.join(','),
          product_types: DEFAULT_MERCHANDISE_PRODUCT_TYPES,
          client_series: endPoints.MANIPAL_SERIES,
          name: searchText,
        });
      default:
        return serverPayload;
    }
  }

  renderModalFooter() {
    return (
      <div>
        <Button onClick={this.emptyCart}>Yes, Empty</Button>
        <Button onClick={this.goToOrderSummery}>No, I want to complete my order</Button>
      </div>
    );
  }

  renderDesktopFilter(isOnlyMerchandise, client_id, category, client_series) {
    const {
      CategoryListArray,
      DiscountListArray,
      urlPath,
    } = this.state;
    const { type, discount } = this.filterCheckList;
    return (
      <Fragment>
        <ListFilters
          // mainTitle="Filters"
          filterTitle="Category"
          filters={client_series === endPoints.LYRA_SERIES ? LYRA_DUMMY_FILTER : CategoryListArray}
          payloadKey="category"
          onChange={this.onCheckBoxClicked}
          isShowSubFilter
          selectedCategories={category}
        />
        {(!isOnlyMerchandise && ![constants.LINK_CLIENT_MANIPAL, constants.LINK_PROPEL_CORPORATE_GIFITING_HOME].includes(urlPath) && client_series !== endPoints.LYRA_SERIES) &&
          <ListFilters
            filterTitle="Type"
            filters={TYPE_FILTERS}
            payloadKey="type"
            onChange={this.onCheckBoxClicked}
            selectedCategories={type}
          />}
        {(client_id === DEFAULT_GIFTCARD_CLIENT && ![constants.LINK_CLIENT_MANIPAL, constants.LINK_SPECIAL_DEALS_AND_OFFERS, constants.LINK_PROPEL_CORPORATE_GIFITING_HOME].includes(urlPath) && client_series !== endPoints.LYRA_SERIES) && (
          <ListFilters
            filterTitle="Discounts"
            filters={DiscountListArray}
            payloadKey="discount"
            onChange={this.onCheckBoxClicked}
            selectedCategories={discount}
          />)}
      </Fragment>
    );
  }

  renderFilter() {
    const {
      mobileFilterData,
      urlPath,
    } = this.state;
    const { client_id } = this.props;
    const {
      isMobileWindow,
      getUserDetails: {
        isOnlyMerchandise = false,
        client_series = '',
      },
    } = this.props;
    const { payloadKey, data } = this.stateLessKeys;
    const { category } = this.filterCheckList;
    if (isMobileWindow) {
      return (
        <Fragment>
          <ListFiltersMobile
            mainTitle="Filters"
            showFilter={this.handleChangeFilters}
            filterResults={data}
            filters={mobileFilterData
              .filter(({ payloadKey: _payloadKey }) => (isOnlyMerchandise || [constants.LINK_CLIENT_MANIPAL, constants.LINK_PROPEL_CORPORATE_GIFITING_HOME].includes(urlPath)) ?
                (_payloadKey !== 'type' && _payloadKey !== 'discount') : true)
              .filter(({ payloadKey: _payloadKey }) => client_id !== DEFAULT_GIFTCARD_CLIENT ? _payloadKey !== 'discount' : true)}
            onChange={this.onCheckBoxClicked}
            payloadKey={payloadKey}
            handleApply={this.handleApply}
            isShowSubFilter
            selectedCategories={category}
          />
        </Fragment>
      );
    }
    return (
      this.renderDesktopFilter(isOnlyMerchandise, client_id, category, client_series)
    );
  }

  renderManipalsignaHeader() {
    return (
      <section className="mb-manipal-banner">
        <img src={endPoints.Mani1.URL} alt={endPoints.Mani1.ALT} className="width-100" />
      </section>
    );
  }

  renderPropelCorporateGiftingCampaignHeader() {
    return (
      <StyledPropelCorporateGiftingCampaignHeader>
        <section className="mb-manipal-banner propel-corporate-gifting-carousel">
          <Carousel effect="scrollx" autoplay autoplaySpeed={4000}>
            <div>
              <img src={IMG_IMPORTS.XMAS_BANNER_CORPORATE_GIFTING.URL} alt={IMG_IMPORTS.XMAS_BANNER_CORPORATE_GIFTING.ALT} className="width-100" />
            </div>
            <div>
              <img src={IMG_IMPORTS.NEWYEAR_BANNER_CORPORATE_GIFTING.URL} alt={IMG_IMPORTS.NEWYEAR_BANNER_CORPORATE_GIFTING.ALT} className="width-100" />
            </div>
          </Carousel>
        </section>
      </StyledPropelCorporateGiftingCampaignHeader>
    );
  }

  renderCouponCode() {
    const {
      CouponCodeList = [],
      isLogedIn,
    } = this.props;
    if (isLogedIn && CouponCodeList.length) {
      return (
        <StyledCouponCodeBox >
          <div className="marquee">
            <p>
              <span className="coupon-description">{CouponCodeList[0].description}
              </span>
              <span className="coupon-code-title">Coupon Code:</span>
              <span className="coupon-code">{CouponCodeList[0].code}</span>
            </p>
          </div>
        </StyledCouponCodeBox>
      );
    }
    return '';
  }

  renderBanner() {
    const { urlPath } = this.state;
    switch (urlPath) {
      case constants.LINK_CLIENT_MANIPAL:
        return this.renderManipalsignaHeader();
      case constants.LINK_PROPEL_CORPORATE_GIFITING_HOME:
        return this.renderPropelCorporateGiftingCampaignHeader();
      default:
        return '';
    }
  }

  render() {
    const { location,
      giftCardDynamicList,
      showModal,
      isShowFilter,
      urlPath,
      voucherRemarks,
      voucherAmount,
    } = this.state; // BrandListArray
    const { client_id } = this.props;
    const { isLoadingStatus,
      getUserDetails: { isOnlyMerchandise = false, client_series = '' },
      onGetGiftCardList,
      isMobileWindow,
      history,
      onStoreLyraGiftCard,
      lyraGiftCardDetails,
      onClearError,
      history: { location: { pathname } },
    } = this.props;
    const isDiscountShow = (client_id === DEFAULT_GIFTCARD_CLIENT) && true;
    const { GIFT_TEXT } = GIFT_TEXT_HEADER;
    if (isLoadingStatus) {
      return <Loader />;
    }
    const {
      slider_images, logo, about_title,
      about_description, secondary_title,
      portal_name, redirect_loginSuccess,
      top_banner, welcome_title,
      welcome_description,
      // isOnlyMerchandise,
      brand_logo, ...otherProps
    } = CONFIG_CLIENT_UI(urlPath);
    return (
      <Fragment>
        <Helmet>
          <title> Zaggle - List of gift cards </title>
        </Helmet>
        <StyledClientLogin {...otherProps}>
          {this.renderBanner()}
          <Container>
            <h1
              className={(isOnlyMerchandise || (urlPath === constants.LINK_CLIENT_MANIPAL) || (urlPath === constants.LINK_PROPEL_CORPORATE_GIFITING_HOME)) ? 'font-26 heading' : 'font-26 margin-t-8 heading'}
            >
              {(isOnlyMerchandise || (urlPath === constants.LINK_CLIENT_MANIPAL) || (urlPath === constants.LINK_PROPEL_CORPORATE_GIFITING_HOME)) ? '' : GIFT_TEXT}
            </h1>
          </Container>
          {(client_id === DEFAULT_GIFTCARD_CLIENT && urlPath !== constants.LINK_CLIENT_MANIPAL && urlPath !== constants.LINK_PROPEL_CORPORATE_GIFITING_HOME && client_series !== endPoints.LYRA_SERIES) && (<TabMenu links={LINK_ARRAY} {...location} />)}
          <Container>
            <Modal
              show={showModal}
              header="Empty Cart?"
              onClose={this.closeModal}
              footer={this.renderModalFooter()}
            >
              <span>Few items in your cart can not redeemed using `{'zaggle cash / selected zaggle card'}`.Do you want to empty your cart first ?</span>
            </Modal>
            {this.renderCouponCode()}
            <Card className="rounded noborder noshadow products-view">
              <Row align="top" type="flex" gutter={24}>
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  <SubTitle fontWeight="800" className="font-20 heading">Filters</SubTitle>
                </Col>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  <StyledSearchBox>
                    <Search
                      placeholder="Search by Brand Name, Category, Type, and Discounts"
                      className="width-6 search_box"
                      allowClear
                      enterButton
                      onSearch={(value) => this.handleSearch(value)}
                    />
                  </StyledSearchBox>
                </Col>
              </Row>
              <Row align="top" type="flex" gutter={24}>
                <Col xs={24} sm={24} md={6} lg={6} xl={6} className="filters-bg">
                  <MobileFiltes>
                    <div className="mobile-filters lg-none">
                      <ul>
                        <li onClick={this.mobileFilterClick} role="presentation"><FontAwesomeIcon name="filter" />Filters</li>
                      </ul>
                    </div>
                    <div className={isShowFilter ? 'show' : 'none'}>
                      {this.renderFilter()}
                    </div>
                  </MobileFiltes>
                </Col>
                {pathname === constants.LYRA_PG_LINK_GIFTCARD_LIST ? (
                  <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                    <Row align="top" type="flex" gutter={24}>
                      <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <LyraGiftLandingCard
                          isMobileWindow={isMobileWindow}
                          OnLyraVourcherRemarksChange={(value) => this.setState({ voucherRemarks: value })}
                          OnLyraVourcherAmountChange={(value) => this.setState({ voucherAmount: value })}
                          voucherRemarks={voucherRemarks}
                          voucherAmount={voucherAmount}
                          history={history}
                          onStoreLyraGiftCard={onStoreLyraGiftCard}
                          lyraGiftCardDetails={lyraGiftCardDetails}
                          onClearError={onClearError}
                        />
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                    {giftCardDynamicList && giftCardDynamicList.data && giftCardDynamicList.data.length ? (
                      <Row align="top" type="flex" gutter={24}>
                        {giftCardDynamicList && giftCardDynamicList.data &&
                        giftCardDynamicList.data.map((card) => (
                          <Col xs={24} sm={24} md={8} lg={8} xl={8} key={card.key}>
                            <GiftLandingCard
                              border={`${theme.gray89} solid 1px`}
                              {...card}
                              onChildEvents={this.onChildEvents}
                              isButtonShow
                              isDiscountShow={isDiscountShow}
                              isMobileWindow={isMobileWindow}
                            />
                          </Col>))}
                      </Row>
                    ) : (<div className="noresult">{(isOnlyMerchandise || urlPath === constants.LINK_CLIENT_MANIPAL) ? TEXT_NO_MERCHANT : TEXT_NO_GIFTCARD}</div>)}
                    <Pagination
                      totalRecords={giftCardDynamicList.totalRecords}
                      module="giftCards"
                      defaultPayload={this.dynamicPayload()}
                      onChange={onGetGiftCardList}
                    />
                  </Col>
                )}
              </Row>
            </Card>
          </Container>
        </StyledClientLogin>
      </Fragment>
    );
  }
}

GiftCard.propTypes = {
  isMobileWindow: bool.isRequired,
  isLogedIn: bool.isRequired,
  isLoadingStatus: bool.isRequired,
  client_id: string.isRequired,
  getDynamicGiftCardList: shape({
    data: array,
    totalRecords: number,
  }).isRequired,
  history: shape({}).isRequired,
  getUserDetails: shape({}).isRequired,
  getCartItemList: shape({}).isRequired,
  filter: shape({
    filterName: string,
    filterId: string,
  }),
  location: shape({}),
  initialPayload: shape({}),
  lyraGiftCardDetails: shape({}),
  getBrandList: array.isRequired,
  getCategoryList: array.isRequired,
  getDiscountList: array.isRequired,
  CouponCodeList: array.isRequired,
  onGetCategoryList: func.isRequired,
  onGetGiftCardList: func.isRequired,
  onAddToCartAction: func.isRequired,
  onCreateCartAction: func.isRequired,
  onDeleteCartItem: func.isRequired,
  onGetCartItemsList: func.isRequired,
  onClearError: func.isRequired,
  onChangeLoginModalDisplay: func.isRequired,
  onStoreLyraGiftCard: func.isRequired,
};
GiftCard.defaultProps = {
  filter: {},
  initialPayload: {},
  location: {},
  lyraGiftCardDetails: {},
};

const mapDispatchToProps = (dispatch) => ({
  onGetCategoryList: (payload) => dispatch(fetchCategoryList(payload)),
  onGetGiftCardList: (payload) => dispatch(fetchGiftCardList(payload)),
  onAddToCartAction: (payload, product_id, type, history, trackingObj) => dispatch(addToCartAction(payload, product_id, type, history, trackingObj)),
  onDeleteCartItem: (payload, actionType, clientid, req_payload, req_action, history, trackingObj) => dispatch(deleteCartItem(payload, actionType, clientid, req_payload, req_action, history, trackingObj)),
  onGetCartItemsList: (payload) => dispatch(fetchCartItemList(payload)),
  onCreateCartAction: (payload, otherProps) => dispatch(createCart(payload, otherProps)),
  onClearError: (payload, actionType) => dispatch(resetPopup(payload, actionType)),
  onChangeLoginModalDisplay: (payload) => dispatch(displayLoginFrom(payload)),
  onStoreLyraGiftCard: (payload) => dispatch(storeLyraGiftCard(payload)),
});

const mapStateToProps = createStructuredSelector({
  getCategoryList: selectCategoryList(),
  getDiscountList: discountList(),
  getBrandList: brandList(),
  getDynamicGiftCardList: giftCardList(),
  getUserDetails: selectHeaderContainerJS('userDetails'),
  getCartItemList: cartItemList(),
  isMobileWindow: isMobileScreen(),
  isLogedIn: selectLoggedIn(),
  isLoadingStatus: select_isBoolean('isLoading'),
  CouponCodeList: selectGiftCardJS('couponCodeList'),
  lyraGiftCardDetails: selectLyraGiftCard('lyraGiftCardDetails'),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(GiftCard));
const GiftCardConnectWrapper = connect(mapStateToProps, mapDispatchToProps)(GiftCard);
export { GiftCard, GiftCardConnectWrapper, mapDispatchToProps, mapStateToProps };
export default component;



// WEBPACK FOOTER //
// client/containers/GiftCard/index.js